export const GET_LAB_TIME_ENTRIES = 'GET_LAB_TIME_ENTRIES';
export const GET_LAB_TIME_ENTRIES_SUCCESS = 'GET_LAB_TIME_ENTRIES_SUCCESS';
export const GET_LAB_TIME_ENTRIES_ERROR = 'GET_LAB_TIME_ENTRIES_ERROR';
export const CREATE_LAB_TIME_ENTRY_SUCCESS = 'CREATE_LAB_TIME_ENTRY_SUCCESS';
export const CREATE_LAB_TIME_ENTRY_ERROR = 'CREATE_LAB_TIME_ENTRY_ERROR';
export const UPDATE_LAB_TIME_ENTRY_SUCCESS = 'UPDATE_LAB_TIME_ENTRY_SUCCESS';
export const UPDATE_LAB_TIME_ENTRY_ERROR = 'UPDATE_LAB_TIME_ENTRY_ERROR';
export const DELETE_LAB_TIME_ENTRY_SUCCESS = 'DELETE_LAB_TIME_ENTRY_SUCCESS';
export const DELETE_LAB_TIME_ENTRY_ERROR = 'DELETE_LAB_TIME_ENTRY_ERROR';
export const ADD_LAB_ENTRY = 'ADD_LAB_ENTRY';
export const DELETE_LAB_ENTRY = 'DELETE_LAB_ENTRY';
export const REVERT_LAB_TIME_ENTRY = 'REVERT_LAB_TIME_ENTRY';
export const UPSERT_LAB_TIME_ENTRY_SUCCESS = 'UPSERT_LAB_TIME_ENTRY_SUCCESS';
export const UPSERT_LAB_TIME_ENTRY_ERROR = 'UPSERT_LAB_TIME_ENTRY_ERROR';
